module.exports = __webpack_public_path__ + "img/L2_Frame.eadfeb94.svg";